module.exports = __webpack_public_path__ + "static/media/LogoEN.5722ec2d.svg";